import { AssignmentDTO } from '@api/models';
import { Component, computed, input } from '@angular/core';
import { TranslatePipe } from '@ngx-translate/core';

@Component({
  selector: 'app-assignment-name',
  templateUrl: './assignment-name.component.html',
  imports: [TranslatePipe],
})
export class AssignmentNameComponent {
  assignment = input.required<AssignmentDTO>();
  origin = computed(() => this.assignment().originPrimaryLocation);
  destination = computed(() => this.assignment().destinationPrimaryLocation);
}
